import type { ExperimentConfig } from '../@types'

// UI-paywall-часть эксперимента удалена (DEV-34602): группа B видит базовый пейвол своей
// воронки, а Move-юзеры помечаются на бэке полем application в create-subscription
// (см. src/modules/WebBilling/composables/useSubscriptionApplication.js).
// Текущая paywall-часть меняет только конфиг: помечает вариант B Move-юзером в Braze
// (config.brazeAttributes → is_moves_user, PR #567).
const config: ExperimentConfig[] = [
	{
		// Раскатаны (EN-only): activity-female-tai-chi-walking-v2 (DEV-33457), -v2-al (DEV-35103),
		// activity-male-military-calisthenics и -pr (DEV-35190). «Move-ность» задаётся их
		// AREA-флагом в useABFeatureFlag → IS_MOVES_FUNNEL. Апселлы раскатанных воронок не
		// меняются: атрибуция выручки к Moves идёт полем application в create-subscription,
		// отдельные Move-продукты в апселле не нужны.
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () => import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
		'activity-female-military-calisthenics': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-military-calisthenics&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					// База upsell-military-calisthenics-f — чистый bundle-activity с гео-ветвлением
					// цен (US/RoW/остальные), поэтому override __activity_m, несмотря на «_m» в имени.
					'upsell-military-calisthenics-f': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_redirect_simple_moves'),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import('@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'),
				},
			},
		},
	},
]

export default config
